import $ from "jquery";
window.jQuery = window.$ = $;
import 'bootstrap';
import swal from "sweetalert";
import {isNullOrUndef} from "chart.js/helpers";
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;

const $http = require('http');

function sweetConfirm(tracking_id) {
    let title = '¿Estás seguro de guardar el seguimiento?';
    let text = '';
    swal({
        icon: 'info',
        title: title,
        text: text,
        buttons: {
            approve: {
                text: "Guardar",
                value: true,
                className: "btn-success",
                closeModal: false
            },
            cancel: {
                text: "Cancelar",
                value: null,
                visible: true,
                className: "",
                closeModal: true
            }
        }
    }).then(function (actionValue) {
        ccyan(actionValue, 'actionValue')
        if(actionValue === true) {
            const url = '/tracking/'+tracking_id+'/record'
            const formData = new FormData();
            formData.append('visit_date', $('#visit-date-'+tracking_id).val());
            formData.append('comment', $('#comment-'+tracking_id).val());
            formData.append('status', $('#status-'+tracking_id).val());
            const photoInput = document.getElementById('photo-' + tracking_id);
            if (photoInput && photoInput.files && photoInput.files[0]) {
                formData.append('photo', photoInput.files[0]); // Append the actual file object
            }
            fetch(url, {
                method: 'PATCH',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    // NO 'Content-Type' header here for FormData!
                },
                body: formData
            })
                .then(response => {
                    // Handle non-OK HTTP responses
                    if (!response.ok) {
                        // If the server responds with an error, throw it so .catch handles it
                        return response.json().then(errorData => {
                            throw new Error(errorData.message || `Server error with status: ${response.status}`);
                        });
                    }
                    return response.json(); // Assuming your Rails controller responds with JSON
                })
                .then(data => {
                    console.log('data = ' + JSON.stringify(data))
                    if (data.success) {
                        swal('Éxito', data.message, 'success').then(() => {
                            // window.location.href = data.path;
                            window.location.reload();
                        });
                    } else {
                        // Server-side validation errors or other failures
                        swal('Error', data.message, 'error');
                    }
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    swal('Error', error.message || 'Hubo un problema al procesar la solicitud.', 'error');
                });
        }
    });
}

function showFullImage(imageUrl) {
    const contentDiv = document.createElement('div');
    const img = document.createElement('img');

    img.className = 'text-centered';
    img.src = imageUrl
    img.width = 700;
    // img.height = 130;
    contentDiv.appendChild(img);

    swal({
        imageUrl: imageUrl, // Use the full image URL here
        imageWidth: 'auto', // Adjust as needed, 'auto' will scale to fit
        imageHeight: 'auto',
        imageAlt: 'Imagen Completa',
        title: 'Imagen del Seguimiento',
        content: contentDiv,
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
        backdrop: true, // Optional: dims the background
        allowOutsideClick: true,

        // width: '900px',
        // width: '60em',
        padding: '2em', // Optional: Add more padding inside the modal for better spacing
        className: 'swal-wide' // Optional: para aplicar estilos CSS personalizados si necesitas más control
    });
}

function updateModalImage(element) {
    // 1. Buscas la URL y la asignas
    let modalImg = document.getElementById('modalImage');
    const fullImageUrl = element.getAttribute('data-bs-remote');
    modalImg.src = fullImageUrl;

    // 2. ABRES EL MODAL USANDO JQUERY
    // Esto funciona tanto en Bootstrap 4 como en 5 si jQuery está cargado
    $('#photoModal').modal('show');
}

// function setupTrackingForm() {
//     const form = document.getElementById("warranties-tracking");
//     if (form) {
//         // $(document)
//         //     .on('select2:select', '#vehicle_vehicles_engines_id', setVehicleProduct)
//         //     .on('change', '#warranty_phone_number', getCustomer)
//     }
// }
// function destroyTracking() {
//     const form = document.getElementById("warranties-tracking");
//     if (form) {
//         // document.removeEventListener("turbolinks:load", setupTrackingForm);
//         // $(document)
//             // .off('select2:select', '#vehicle_vehicles_engines_id', setVehicleProduct)
//             // .off('change', '#warranty_phone_number', getCustomer)
//     }
// }
// document.addEventListener("turbolinks:load", setupTrackingForm);
// window.addEventListener('beforeunload', (event) => {
//     destroyTracking();
// });

window.updateModalImage = updateModalImage;
window.sweetConfirm = sweetConfirm
window.showFullImage = showFullImage
// window.checkStatus = checkStatus